import ErrorIcon from '@mui/icons-material/Error';
import { FormControl, FormHelperText, TextField } from '@mui/material';
import type { InputLabelProps } from '@mui/material';
import type { ChangeEvent, CSSProperties, FocusEvent as ReactFocusEvent, ReactNode } from 'react';

type FormInputProps = {
	label?: string;
	name: string;
	type?: string;
	value: string;
	error?: string | string[] | undefined;
	onChange: (e: ChangeEvent<HTMLInputElement>) => void;
	onBlur?: (e: ReactFocusEvent<HTMLInputElement | HTMLTextAreaElement> | undefined) => void;
	readOnly?: boolean;
	endAdornment?: ReactNode;
	placeholder?: string;
	style?: CSSProperties;
	customInputLabelProps?: InputLabelProps;
};

function FormInput({
	label = '',
	name,
	type = 'text',
	value,
	error,
	onChange,
	onBlur,
	placeholder = '',
	style = {},
	readOnly = false,
	endAdornment = null,
	customInputLabelProps = {},
}: FormInputProps) {
	return (
		<FormControl style={{ padding: 0 }} fullWidth variant="outlined" error={!!error}>
			<TextField
				label={label}
				name={name}
				type={type}
				fullWidth
				required
				margin="normal"
				value={value}
				autoComplete="new-password"
				error={!!error}
				onChange={onChange}
				onBlur={event => onBlur?.(event)}
				placeholder={placeholder}
				style={style}
				sx={{
					'& .MuiOutlinedInput-root': {
						backgroundColor: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? 'hsla(0, 0%, 85%, 1)' : 'inherit',
					},
					'& .MuiFormLabel-asterisk': {
						display: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? 'none' : 'inline',
					},
				}}
				slotProps={{
					input: { endAdornment, readOnly },

					htmlInput: {
						'data-testid': name,
					},

					inputLabel: {
						...customInputLabelProps,
						shrink: true,
					},
				}}
			/>
			{error && Array.isArray(error)
				? error.map((err, index) => (
						<FormHelperText
							key={index}
							data-testid="error-message"
							style={{
								...(globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
									? {
											marginLeft: '0px',
											marginRight: '0px',
											display: 'flex',
											gap: '4px',
											alignItems: 'flex-start',
										}
									: {}),
							}}
						>
							<ErrorIcon fontSize="small" style={{ verticalAlign: 'middle' }} /> {err}
						</FormHelperText>
					))
				: error && (
						<FormHelperText
							data-testid="error-message"
							style={{
								...(globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
									? {
											marginLeft: '0px',
											marginRight: '0px',
											display: 'flex',
											gap: '4px',
											alignItems: 'flex-start',
										}
									: {}),
							}}
						>
							<ErrorIcon fontSize="small" style={{ verticalAlign: 'middle' }} /> {error}
						</FormHelperText>
					)}
		</FormControl>
	);
}

export default FormInput;
